"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2001StatsToJSON = exports.InlineResponse2001StatsFromJSONTyped = exports.InlineResponse2001StatsFromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineResponse2001StatsFromJSON(json) {
    return InlineResponse2001StatsFromJSONTyped(json, false);
}
exports.InlineResponse2001StatsFromJSON = InlineResponse2001StatsFromJSON;
function InlineResponse2001StatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'total': !(0, runtime_1.exists)(json, 'total') ? undefined : json['total'],
        'processed': !(0, runtime_1.exists)(json, 'processed') ? undefined : json['processed'],
        'updated': !(0, runtime_1.exists)(json, 'updated') ? undefined : json['updated'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : json['errors'],
    };
}
exports.InlineResponse2001StatsFromJSONTyped = InlineResponse2001StatsFromJSONTyped;
function InlineResponse2001StatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total': value.total,
        'processed': value.processed,
        'updated': value.updated,
        'errors': value.errors,
    };
}
exports.InlineResponse2001StatsToJSON = InlineResponse2001StatsToJSON;
